// extracted by mini-css-extract-plugin
module.exports = {"navFooter":"styles_navFooter__16r6f","navFooterItem":"styles_navFooterItem__1ZDF5","navFooterBtn":"styles_navFooterBtn__zB8lS"};